var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry-preview",style:({'pointer-events': (_vm.disableClicks)? 'none': ''})},[_c('div',{ref:"container",staticClass:"preview__container"},[_c('div',{staticClass:"preview__wrapper",style:({
        width: '100%',
        'max-width': ((_vm.iframe.innerWidth / _vm.iframeZoom) + "px"),
        height: ((_vm.iframe.innerHeight / _vm.iframeZoom) + "px"),
      })},[_c('iframe',{ref:"iframe",staticClass:"preview__iframe",style:({
          width: ((_vm.iframe.innerWidth * _vm.iframeZoom) + "px"),
          height: ((_vm.iframe.innerHeight * _vm.iframeZoom) + "px"),
          transform: ("scale(" + _vm.iframeScale + ")"),
          zoom: _vm.iframeScale,
        }),attrs:{"srcdoc":_vm.content,"scrolling":"no","frameborder":"0"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }